import { Box, Grid } from "@mui/material";
import React, { FC } from "react";
import { UserInfo as UserInfoModel} from "../../../../reducers/states/user-info";
import { useAgency } from "../../../../hooks/agencies";

const UserInfo: FC<{ userInfo: UserInfoModel }> = ({ userInfo }) => {
  const agency = useAgency(userInfo.agency);
  // todo: jcavner: If the useAgency hook had a getShortName(id) function, like the jogs hook, it could provide this fallback functionaliy.
  const agencyName = agency?.shortName || userInfo.agency;

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box m={0.5}>
          Name: {`${userInfo.firstName ?? ""} ${userInfo.lastName ?? ""}`}
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box m={0.5}>Agency: {agencyName}</Box>
      </Grid>
      <Grid item xs={12}>
        <Box m={0.5}>Phone: {userInfo.phoneNumber}</Box>
      </Grid>
      <Grid item xs={12}>
        <Box m={0.5}>Email: {userInfo.email}</Box>
      </Grid>
    </Grid>
  );
};

export default UserInfo;
